import React, { useState } from "react";
import "../styles/AddEntryForm.css";

/*	Purpose: To raise the account level of an existing user to admin by entering its account information
	Input: Existing User's information (email, firstName, lastName, password, username)
	Output: Message of successful operation (Raising the target account to Admin)
	Errors: Displays if errors in executing oppertaion (user doesnt exist, user is admin already, target user is current user, etc.)
 */
const RaiseAdminFrom = ({ onSubmit, onCancel }) => {
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		username: "",
		password: "",
		email: "",
		mfa: true,
	});

	const handleSubmit = (e) => {
		e.preventDefault();

		onSubmit(formData);
	};

	return (
		<div className="raise-admin">
			<h2>Raise an Account to Admin</h2>
			<form onSubmit={handleSubmit}>
				{/* <div className="form-group">
					<label>First Name:</label>
					<input
						type="text"
						value={formData.firstName}
						onChange={(e) =>
							setFormData({
								...formData,
								firstName: e.target.value,
							})
						}
						required
					/>
				</div>
				<div className="form-group">
					<label>Last Name:</label>
					<input
						type="text"
						value={formData.lastName}
						onChange={(e) =>
							setFormData({
								...formData,
								lastName: e.target.value,
							})
						}
						required
					/>
				</div>
				<div className="form-group">
					<label>Username:</label>
					<input
						type="text"
						value={formData.username}
						onChange={(e) =>
							setFormData({
								...formData,
								username: e.target.value,
							})
						}
						required
					/>
				</div> */}
				<div className="form-group">
					<label>Email:</label>
					<input
						type="email"
						value={formData.email}
						onChange={(e) =>
							setFormData({
								...formData,
								email: e.target.value,
							})
						}
						required
					/>
				</div>
				{/* <div className="form-group">
					<label>Password:</label>
					<input
						type="email"
						value={formData.password}
						onChange={(e) =>
							setFormData({
								...formData,
								password: e.target.value,
							})
						}
						required
					/>
				</div> */}
				{/* <div className="form-group">
					<label>Enable Multi-Factor Authentication?</label>
					<select
						className="checkBox"
						type="checkbox"
						value={formData.mfa}
						onChange={(e) => setFormData({
								...formData,
								mfa: e.target.value,
							})}
						required
					>
						<option value="true">Yes</option>
						<option value="false">No</option>
					</select>
				</div> */}
				<button type="submit" className="action-button">
					Raise to Admin
				</button>
			</form>
		</div>
	);
};

export default RaiseAdminFrom;
